import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Card, CardBody, Table } from "reactstrap"
import { useDispatch } from "react-redux"

import Paginations from "components/Common/Pagination"
import { deleteCatering } from "store/actions/trialPeriodAction"
import { showAlert } from "store/reducers/alertReducer"
import DeleteModal from "components/Common/DeleteModal"
import { useSelector } from "react-redux"
import NoDataAvailable from "../../../components/Shared/NoDataAvailable"

const headers = [
  "S. No.",
  "Shift",
  "Station",
  "Meal Type",
  "Status",
  "Created By",
  "Note",
]

const CateringTable = ({
  onPageChange,
  data,
  currentPage,
  totalPages,
  totalCount,
  trigger,
  loading,
  perPage,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()

  const [itemIdToDelete, setItemIdToDelete] = useState(null)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const { work_shifts, stations, mealTypes } = useSelector(
    state => state.Common
  )

  const showDataFromObject = (list, key) => {
    const keys = Object.keys(list)
    if (keys.length === 0) return "-"

    return list[key][language === "en" ? "name" : "name_ar"]
  }
  const handleDelete = () => {
    dispatch(deleteCatering(itemIdToDelete))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
          setShowDeleteModal(false)
          setItemIdToDelete(null)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <>
      <Card className="overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((header, index) => (
                    <th key={index}>{t(header)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">
                      {(currentPage - 1) * perPage + index + 1}
                    </th>
                    <td>
                      {
                        work_shifts[item.shift][
                          language === "en" ? "name" : "name_ar"
                        ]
                      }
                    </td>
                    <td>
                      {
                        stations[item.station][
                          language === "en" ? "name" : "name_ar"
                        ]
                      }
                    </td>
                    <td>{showDataFromObject(mealTypes, item.meal_type)}</td>
                    <td>
                      {item.status === "not_received"
                        ? t("Not Received")
                        : t("Received")}
                    </td>
                    <td>{item.created_by}</td>
                    <td>
                      {item.notes?.length > 30
                        ? `${item.notes.slice(0, 30)}...`
                        : item.notes || "-"}{" "}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {!loading && data.length === 0 && <NoDataAvailable />}
        </CardBody>
      </Card>
      {data.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
      {showDeleteModal && itemIdToDelete && (
        <DeleteModal
          show={showDeleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={() => {
            setItemIdToDelete(null)
            setShowDeleteModal(false)
          }}
          // isLoading={isLoading}
          buttonText={t("Delete")}
          bodyTitle={t("Are you sure you want to delete this Schedule?")}
        />
      )}
    </>
  )
}

export default CateringTable
